import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";

import { FaLinkedinIn } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Row className="align-items-center">

        {/* LEFT */}
        <Col md={4} className="footer-copywright">
          <h3>
            Designed & Developed by
          </h3>

          <h3>
            <span className="purple">
              Gaurav Kumar
            </span>
          </h3>

          <p
            style={{
              color: "#bdbdbd",
              marginTop: "5px",
              fontSize: "14px",
            }}
          >
            Full Stack Software Engineer
          </p>
        </Col>

        {/* CENTER */}
        <Col md={4} className="footer-copywright">
          <h3
            style={{
              fontStyle: "italic",
              fontWeight: "400",
              lineHeight: "1.6",
            }}
          >
            "Engineering scalable software solutions and transforming ideas into impactful digital experiences."
          </h3>

          <p
            style={{
              marginTop: "10px",
              color: "#c770f0",
              fontSize: "14px",
            }}
          >
            — Gaurav Kumar
          </p>
        </Col>

        {/* RIGHT */}
        <Col md={4} className="footer-body">

          <ul className="footer-icons">

            <li className="social-icons">
              <motion.a
                whileHover={{
                  scale: 1.25,
                  y: -3,
                }}
                href="https://github.com/gauravjha0711"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                <AiFillGithub />
              </motion.a>
            </li>

            <li className="social-icons">
              <motion.a
                whileHover={{
                  scale: 1.25,
                  y: -3,
                }}
                href="https://leetcode.com/u/gauravjha0711/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SiLeetcode
                  size={22}
                  color="#FFA116"
                />
              </motion.a>
            </li>

            <li className="social-icons">
              <motion.a
                whileHover={{
                  scale: 1.25,
                  y: -3,
                }}
                href="https://www.linkedin.com/in/gaurav-kumar-729503265/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                <FaLinkedinIn />
              </motion.a>
            </li>

            <li className="social-icons">
              <motion.a
                whileHover={{
                  scale: 1.25,
                  y: -3,
                }}
                href="https://www.instagram.com/gauravjhagk"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white" }}
              >
                <AiFillInstagram />
              </motion.a>
            </li>

          </ul>

          <p
            style={{
              marginTop: "10px",
              color: "#bdbdbd",
              fontSize: "14px",
            }}
          >
            © {year} All Rights Reserved
          </p>

        </Col>
      </Row>
    </Container>
  );
}

export default Footer;